import React, { useState, useEffect } from "react";
import {
    CloudArrowUpIcon,
    LockClosedIcon,
    ServerIcon,
} from "@heroicons/react/20/solid";
import { useLocation } from "react-router-dom";
import broomIcon from "../../assets/icons/broom.svg";
import eventIcon from "../../assets/icons/event.svg";
import canopyIcon from "../../assets/icons/canopy.svg";
import trophyIcon from "../../assets/icons/trophy.svg";
import sportsDrinkIcon from "../../assets/icons/sportsDrink.svg";
import enjoyTournamentImage from "../../assets/enjoyTournament.jpg";
import chooseYourTourneyImage from "../../assets/chooseYourTourney.png";
import chooseYourPackageImage from "../../assets/chooseYourPackage.png";
import chooseYourAddOnsImage from "../../assets/chooseYourAddOns.png";
import { Link } from "react-scroll";

const features = [
    {
        name: "Choose your tournament.",
        description:
            "Choose from the list of tournaments we support. If you don't see your tournament, let us know!",
        icon: eventIcon,
        image: chooseYourTourneyImage,
    },
    {
        name: "Select your package.",
        description: "Choose a size that best fits your team.",
        icon: canopyIcon,
        image: chooseYourPackageImage,
    },
    {
        name: "Sweeten your setup with add-ons",
        description:
            "Add gatorade or water to your cooler -- stay hydrated!",
        icon: sportsDrinkIcon,
        image: chooseYourAddOnsImage,
    },
    {
        name: "Enjoy your tournament.",
        description:
            "Show up and enjoy a hassle-free experience with your family and team. When you're done, head home and we'll take care of breakdown and cleanup.",
        icon: trophyIcon,
        image: enjoyTournamentImage,
    },
];

export default function Process2() {
      const location = useLocation();
    
    // Track the index of the feature whose icon is shown on the RHS
    const [selectedIndex, setSelectedIndex] = useState(0);

     useEffect(() => {
        if (location.hash) {
          let elem = document.getElementById(location.hash.slice(1));
          if (elem) {
            elem.scrollIntoView({ behavior: "smooth" });
          }
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      }, [location]);

    return (
        <div id="process" className="overflow-hidden bg-ttNavy-500 py-16 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-white sm:text-5xl">
                    We've got you covered from booking to last whistle.
                </p>
                <p className="mt-6 text-lg/8 text-gray-300">
                    Our concierge process only takes a few minutes to finish. We'll take
                    care of everything else so you can focus on the game.
                </p>
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-10">
                    <div className="lg:pr-8 lg:pt-4 lg:col-span-4">
                        <div className="lg:max-w-lg">
                            <dl className="mt-6 max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">
                                {features.map((feature, idx) => (
                                    <div
                                        key={feature.name}
                                        className="flex items-start group"
                                        onMouseEnter={() => setSelectedIndex(idx)}
                                    >
                                        <img
                                            src={feature.icon}
                                            alt=""
                                            aria-hidden="true"
                                            className="h-12 mt-4 w-auto group-hover:brightness-125"
                                        />
                                        <div className="ml-4">
                                            <dt className="font-semibold text-white group-hover:text-ttOrange-500">
                                                {feature.name}
                                            </dt>
                                            <dd className="group-hover:text-white">
                                                {feature.description}
                                            </dd>
                                        </div>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                    <div className="lg:pt-4 lg:col-span-6 flex items-center">
                        <img
                            src={features[selectedIndex].image}
                            alt={features[selectedIndex].name}
                            className="w-3/4 max-w-none rounded-xl shadow-xl ring-1 ring-white/10 md:-ml-4 lg:-ml-0"
                        />
                    </div>
                </div>
            </div>
            {/* <div className="button hidden sm:mt-12 sm:flex sm:justify-center">
                <Link to="#packages">
                    <button
                        type="button"
                        className="relative rounded-full px-3 py-1 text-md leading-6 text-gray-200 ring-1 ring-ttOrange-500/10 hover:ring-ttOrange-500/20"
                    >
                        Ready to dive into the packages? {" "}
                        <span
                            className="font-semibold text-ttOrange-500"
                            aria-hidden="true"
                        >
                            Let's Go!{" "}
                        </span>{" "}
                        <span aria-hidden="true">&rarr;</span>
                    </button>
                </Link>
            </div> */}
            <div className="button hidden sm:mt-6 sm:flex sm:justify-center">
                <Link to="faq" smooth={true} duration={500}>
                    <button
                        type="button"
                        className="relative rounded-full px-3 py-1 text-md leading-6 text-gray-200 ring-1 ring-ttOrange-500/10 hover:ring-ttOrange-500/20"
                    >
                        Want to know more? Take a look at some {" "}
                        <span
                            className="font-semibold text-ttOrange-500"
                            aria-hidden="true"
                        >
                            frequently asked questions{" "}
                        </span>{" "}
                        <span aria-hidden="true">&rarr;</span>
                    </button>
                </Link>
            </div>
        </div>
    );
}
